export const API_BASE =
  process.env.NODE_ENV === "production" ? "https://www.squares-app.com/api" : "/api";



// WEBPACK FOOTER //
// ./src/api.js